import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginatedFetchTable from '../PaginatedFetchTable';
import Avatar from '../Avatar';
import Icon from '../Icon';
import LinkCopyButton from '../LinkCopyButton';


export default class StaffDiscussionsList extends Component {
  static propTypes = {
    timezone: PropTypes.string,
    timestampFormat: PropTypes.string,
    apiUrl: PropTypes.string,
    perPage: PropTypes.number.isRequired,
    emptyImg: PropTypes.string.isRequired,
    defaultSort: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      className: PropTypes.string,
      sort: PropTypes.shape({
        id: PropTypes.string.isRequired,
        direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
      }),
    })).isRequired,
  };

  static defaultProps = {
    timezone: moment.tz.guess(),
    timestampFormat: 'MMMM D [at] h:mm A z',
    defaultSort: null,
    apiUrl: '',
  }

  renderRow = (item) => (
    <tr key={item.id}>
      <td>
        <a className="u-truncate u-block u-font-semibold" href={item.staff_url}>{item.title}</a>
      </td>
      <td>
        <div className="u-truncate">
          <Avatar
            className="StaffTable-avatar u-align-middle u-mr-2  u-inline-block"
            src={item.user.avatar_url}
            type="user"
            href={item.user.staff_url}
            showInitials
            name={item.user.name}
            />
          <a
            className="u-font-semibold comma-separated"
            href={item.user.staff_url}
            >
            {item.user.name}
          </a>
        </div>
      </td>
      <td>
        <span title={moment(item.created_at).tz(this.props.timezone).format(this.props.timestampFormat)}>{item.created_ago}</span>
      </td>
      <td>
        {item.views_count}
      </td>
      <td>
        {item.comments_count}
      </td>
      <td>
        {item.votes_count}
      </td>
      <td>
        <span title={moment(item.relative_last_activity_timestamp).tz(this.props.timezone).format(this.props.timestampFormat)}>{item.relative_last_activity_date}</span>
      </td>
      <td className="actions">
        <a href={item.edit_staff_url} className="Button u-mr-2">
          <Icon name="edit" className="u-mr-0" />
        </a>
        <div className="u-inline-block">
          <LinkCopyButton url={item.public_url} name={item.title} />
        </div>
      </td>
    </tr>
  );

  render() {
    const {
      apiUrl, perPage, emptyImg, columns, defaultSort,
    } = this.props;
    return (
      <PaginatedFetchTable
        apiUrl={apiUrl}
        perPage={perPage}
        emptyImg={emptyImg}
        columns={columns}
        defaultSort={defaultSort}
        renderRow={this.renderRow}
      />
    );
  }
}
